import script from "./addUser.vue?vue&type=script&setup=true&lang=js"
export * from "./addUser.vue?vue&type=script&setup=true&lang=js"

import "./addUser.vue?vue&type=style&index=0&id=7a2801ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a2801ae"]])

export default __exports__